export default "__VITE_ASSET__BblmvyzQ__"